import V from 'gcl/com/coooders/common/tool';
import C from 'gcl/com/coooders/collection/pool';
import R from 'gcl/com/coooders/module/cron';
import M from 'gcl/com/coooders/bean/middler';
import Conf from 'gcl/com/coooders/io/config';
/**
 * 定义生产消费者基本类和方法定义
 * @param {进程名} name 
 */
export const AProcess = class {
    constructor(worker, log) {
        pri(this, { worker, log });
    }
    get Log() {
        return pri(this).__.log;
    }
    async init() {
        return pri(this).__.worker.init(this);
    }
    async start() {}
    async stop() {}
    dispose() {
        const { __ } = pri(this);
        for (let i in __) try { delete __.i; } catch (e) {}
    }
};

/**
 * 逻辑对象用于真实的生产数据和消费数据
 * @param {*} name 
 */
export const AWorker = class {
    constructor(name) {
        pri(this, { name });
    }
    init(proc) {
        const { __ } = pri(this, { proc });
    }
    get Name() {
        return pri(this).__.name;
    }
    get Log() {
        return pri(this).__.proc.Log;
    }
    async create(data) {}
    async custom(ret, data) {}
    async rollback(ret, data) {}
    async dispose(data) {}
}

/**
 * 创造customer来处理任务
 */
export const CACProcess = class extends AProcess {
    constructor(worker, log, customersize, waittime) {
        super(worker, log);
        const { _, __ } = pri(this, {
            canRun: false,
            data: {},
            //现在待处理的数据有
            datas: [],
            startcreate: false,
            //现在使用的会话有
            sessions: 0,
            usesessions: 0,
            waitsessions: [],
            customersize,
            waittime,
            checker: new class {
                constructor() {
                    pri(this, { canRun: false });
                }
                start() {
                    const that = pri(this);
                    that.__.canRun = true;
                    this.go();
                }
                stop() {
                    const that = pri(this);
                    that.__.canRun = false;
                }
                go() {
                    const that = pri(this);
                    if (that.__.canRun && __.waittime > 0)
                        setTimeout(async() => {
                            try {
                                if (__.waitsessions.length && __.waitsessions[0].waittime.diff('s', new Date()) >= __.waittime / 1000) {
                                    const sessions = __.waitsessions;
                                    __.waitsessions = [];
                                    console.log('关闭等待中的session:' + sessions.length);
                                    await V.each(sessions, async v => {
                                        try {
                                            await v.dispose();
                                        } catch (e) {
                                            console.log('session dispose:', e.message);
                                        } finally {
                                            __.sessions--;
                                            __.dispose();
                                        }
                                    });
                                    console.log('多余的等待会话关闭完成');
                                    V.watch();
                                }
                            } catch (e) {
                                console.log('Check Exception:' + e.message);
                            }
                            that._.go();
                        }, __.waittime);
                }
            },
            Session: class {
                constructor() {
                    pri(this, { data: { id: V.random() } });
                }
                get Id() {
                    return pri(this).__.data.id;
                }
                custom(ret) {
                    const that = pri(this);
                    (__.worker.Name && !that.__.data[__.worker.Name] && (that.__.data[__.worker.Name] = {}));
                    return V.callback2(__.worker.custom, __.worker, ret, that.__.data[__.worker.Name] || that.__.data);
                }
                rollback(ret) {
                    const that = pri(this);
                    (__.worker.Name && !that.__.data[__.worker.Name] && (that.__.data[__.worker.Name] = {}));
                    return V.callback2(__.worker.rollback, __.worker, ret, that.__.data[__.worker.Name] || that.__.data);
                }
                dispose() {
                    const that = pri(this);
                    (__.worker.Name && !that.__.data[__.worker.Name] && (that.__.data[__.worker.Name] = {}));
                    return V.callback2(__.worker.dispose, __.worker, that.__.data[__.worker.Name] || that.__.data);
                }
            },
            next: function(session) {
                //console.log('use:' + __.usesessions + ':' + __.waitsessions.length + ":" + __.sessions);
                __.usesessions--;
                if (__.canRun) {
                    __.waitsessions[__.waitsessions.length] = session;
                    session.waittime = new Date();
                    V.once(function() { __.go() });
                } else {
                    if (__.datas.length) {
                        //无法继续运行 销毁数据
                        const datas = __.datas;
                        __.datas = [];
                        console.log('回滚处理:' + datas.length + e2.stack);
                        V.each(datas, v => session.rollback(v)).then(() => {
                            console.log('回滚处理完成');
                            session.dispose().then(() => {
                                __.sessions--;
                                __.dispose();
                            }).catch(e => {
                                __.sessions--;
                                __.dispose();
                            });
                        }).catch(e => {
                            console.log('rollback的错误,会导致数据丢失:' + e.stack);
                        });
                    } else if (__.isDispose)
                        session.dispose().then(() => {
                            __.sessions--;
                            __.dispose();
                        }).catch(e => {
                            __.sessions--;
                            __.dispose();
                        });
                }
            },
            dispose: function() {
                if (__.sessions == 0 && __.isDispose) {
                    _.supdispose();
                    V.watch();
                    console.log('end');
                }
            },
            createSession: function() {
                let session = __.waitsessions.pop();
                if (session) { __.usesessions++; return session; } else if (__.sessions < __.customersize) {
                    session = new __.Session();
                    __.sessions++;
                    __.usesessions++;
                    return session;
                } else throw new Error('已经达到会话限制上限:' + __.customersize);
            },
            go: function() {
                try {
                    if (__.canRun) {
                        if (__.datas.length)
                            try {
                                const session = __.createSession();
                                delete session.waittime;
                                let v = __.datas.shift();
                                session.custom(v).then(() => {
                                    __.next(session);
                                }).catch(e => {
                                    __.datas.unshift(v);
                                    console.log('go ex:', e.message);
                                    __.next(session);
                                });
                                V.once(function() { __.go() });
                            } catch (e2) {
                                //达到会话上限
                                console.log(e2.message);
                            }
                        else if (!__.startcreate) {
                            __.startcreate = true;
                            (__.worker.Name && !__.data[__.worker.Name] && (__.data[__.worker.Name] = {}));
                            V.callback2(__.worker.create, __.worker, __.data[__.worker.Name] || __.data).then(data => {
                                __.startcreate = false;
                                if (data != null) {
                                    __.datas[__.datas.length] = data;
                                    V.once(function() { __.go() });
                                } else
                                    V.once(function() { __.go() }, 1000);
                            }).catch(e => {
                                __.startcreate = false;
                                console.log('暂时没有数据！需要等待!' + e.stack);
                                V.once(function() { __.go() }, 1000);
                            });
                        }
                    }
                } catch (e) {
                    console.log('等待处理结束1:' + e.stack);
                    V.once(function() { __.go() });
                }
            }
        });
    }
    async start() {
        const { __ } = pri(this);
        __.canRun = true;
        V.watch(true);
        __.go();
        __.checker.start();
        return false;
    }
    async stop() {
        const { __ } = pri(this);
        __.canRun = false;
        __.checker.stop();
        return false;
    }
    async dispose() {
        const { __ } = pri(this);
        this.stop();
        __.isDispose = true;
        return false;
    }
    supdispose() {
        super.dispose();
    }
}

/**
 * 用于处理批量数据处理 需要custom执行批量处理
 * 高性能worker要求，
 * 数据库读取分离，尽量保证读取单独的一个连接，然后记得result.clear()否则会产生大量无用数据 占据内存。
 * 数据库写入尽量使用一个连接事务批量写入，也可以少量连接事务批量写入，然后延后定时提交。
 * 会话数量应低于CPU数量大于2，排除读取的几个连接后，剩下的连接。一般为3，最大不超过10-3,10为默认线程池数量
 * @param {*} name 
 * @param {*} minsize 
 */
export const ADataWorker = class extends AWorker {
    constructor(name, minsize = 5, waitTime = 1000, maxwaitTime = 30000) {
        super(name);
        pri(this, { datas: [], minsize, isRead: false, waitTime: waitTime, maxwaitTime });
        this.waitTime = waitTime;
    }
    create(data, call) {
        const { _, __ } = pri(this);
        if (__.datas.length < __.minsize && !__.isRead) {
            __.isRead = true;
            V.callback2(_.getData, _, data).then(datas => {
                if (datas && datas.length > 0) {
                    __.datas = __.datas.concat(datas);
                    __.isRead = false;
                    _.waitTime = __.waitTime;
                    //call(null, __.datas.shift());
                } else {
                    V.once(() => {
                        __.isRead = false;
                        _.waitTime = Math.min(_.waitTime * 2, __.maxwaitTime);
                        //console.log('waittime:', _.waitTime);
                    }, _.waitTime);
                    //call(null, __.datas.shift());
                }
            }).catch(e => {
                V.once(() => {
                    __.isRead = false;
                    _.waitTime = __.waitTime;
                }, _.waitTime);
                console.log('大批量数据生产失败!', e.message);
                //call(e);
            });
        }
        call(null, __.datas.shift());
    }
    getData(data, call) {
        call(null, []);
    }
};

/**
 * jobs
 * @param {*} name 
 * @param {*} jobs 
 */
export const CronWorker = class extends AWorker {
    constructor(name, jobs = []) {
        super(name);
        pri(this, { jobs, lstjob: [] });
    }

    init(proc) {
        super.init(proc);
        this.sortjobs();
    }

    /**
     * 重新排序
     */
    sortjobs() {
        const { _, __ } = pri(this);
        __.jobs.forEach(v => {
            const time = v.time || v.next();
            v.time = time;
            if (!time) { console.log(v.Name + 'job未能定义执行时间!'); return; }
        });
        __.lstjob = __.jobs.concat([]).sort((a, b) => {
            return a.time.getTime() - b.time.getTime();
        });
    }

    create(data) {
        const { _, __ } = pri(this);
        if (__.lstjob[0].time.getTime() < (new Date().getTime())) {
            console.log('过期了');
            const v = __.lstjob.shift();
            delete v.time;
            _.sortjobs();
            return v;
        } else
            return null;
    }
    async custom(ret, data) {
        (ret.Name && !data[ret.Name]) && (data[ret.Name] = {});
        await V.callback2(ret.go, ret, data[ret.Name] || data);
        return false;
    }
};

/**
 * 克隆任务
 * 用于对应克隆表达式后执行go方法操作
 * @param {*} 名称 
 * @param {0 0 * * ? *} 克隆表达式 
 */
export const ACronJob = class {
    constructor(name, cronexp) {
        pri(this, { name, cron: new R.Cron(cronexp) });
    }
    get Name() {
        return pri(this).__.name;
    }
    next() {
        return pri(this).__.cron.next();
    }
    async go(data) {
        return false;
    }
};

/**
 * 供外部继承后作为单一应用启动 使用方式 node ***.js test.npcf,env.npcf ss1worker
 * 函数本身具有 Config Log Middler NiTemplate 4个对象
 */
export const start = async function(func) {
    try {
        if (process.argv.length < 3) throw new Error('命令格式错误 应为 node ***.js test.npcf,env.npcf processname 或者 node ***.js test.npcf,env.npcf');
        const cm = process.argv.length > 2 ? await Conf.getApplicationConfigManagerFromFile(process.argv[2].split(',')) : await Conf.getApplicationConfigManager();
        const Middler = new M.Middler(cm);
        const log = Middler.getObjectByAppName('MPC', 'Logger');
        const NiTemplate = Middler.getObjectByAppName('Ni', 'MT');
        let proc = func ? await V.callback2(func, { Config: cm, Middler, Log: log, Ni: NiTemplate }) : Middler.getObjectByAppName('MPC.Process', process.argv.length > 3 ? process.argv[3] : process.argv[2]);
        try {
            if (!proc) throw new Error('没找到process对象定义!');
            if (!V.isArray(proc)) proc = [proc];
            await V.each(proc, async v => {
                try {
                    await v.init();
                    await v.start();
                    log.release((v.Name || v.name || '部分Process') + '启动成功');
                    console.log((v.Name || v.name || '部分Process') + '启动成功');
                } catch (e) {
                    log.error((v.Name || v.name || '部分Process') + '启动失败:' + e.stack);
                    console.log((v.Name || v.name || '部分Process') + '启动失败:' + e.stack);
                }
                return false;
            });
        } catch (e2) {
            log.error('启动失败:' + e2.stack);
            throw e2;
        }
    } catch (e) {
        console.log('启动失败:' + e.stack);
    }
};

/**
 * 用于批量数据处理 需要bulkcustom执行批量处理
 * 高性能worker
 * 数据库读取分离，尽量保证create单独的一个连接，然后记得result.clear()否则会产生大量无用数据 占据内存。
 * 数据库或者es写入尽量使用一个连接事务批量写入，也可以少量连接事务批量写入，延后定时提交不可取 改为批量。
 * custome
 * bulklength为一次批量插入的数据总数 默认为1000
 * 
 * @param {*} name 
 * @param {*} minsize 
 */
export const ABulkWorker = class extends ADataWorker {
    constructor(name, minsize, waitTime, maxwaitTime, bulklength = 1000) {
        super(name, minsize, waitTime, maxwaitTime);
        pri(this, { bulklength });
    }

    /**
     * 单条处理逻辑，将单条数据填充在会话对象datas属性数组中
     * 在满足bulklength极限长度后进行批量处理
     * 设计中会导致填满一个会话后再启动一个会话继续填充
     * @param {数据数组} ret 
     * @param {会话对象} data 
     */
    async custom(ret, data) {
        const { _, __ } = pri(this);
        try {
            if (!data.datas) data.datas = [];
            data.datas[data.datas.length] = ret;
            if (data.datas.length >= __.bulklength) {
                const datas = data.datas;
                data.datas = [];
                try {
                    await _.bulkcustom(datas, data);
                } catch (e2) {
                    console.log('bulkcustom错误', e2.message);
                    data.backdatas = datas;
                }
            }
        } finally {
            if (data.backdatas) {
                data.datas = data.datas.concat(data.backdatas);
                console.log('custom错误,datas重新进入会话池子', data.backdatas.length);
                delete data.backdatas;
            }
        }
        return false;
    }

    /**
     * 用于批量完成数据处理，与custom不同 首参数是数组然后是会话信息，自定义的dispose方法需要调用super.dispose
     * @param {数据数组} rets 
     * @param {会话对象} data 
     */
    async bulkcustom(rets, data) {
        //完成批量插入数据操作。
        return false;
    }

    /**
     * 关闭会话时重新清理其未处理完的data.datas数据
     * @param {*} data 
     */
    async dispose(data) {
        while (data.datas && data.datas.length > 0) {
            try {
                await this.bulkcustom(data.datas, data);
                delete data.datas;
            } catch (e) {
                console.log('ABulkWorker dispose 持续报错可能导致死循环，杀死进程可能丢失数据:', e.stack);
            }
        }
        await super.dispose(data);
    }
};

export const AmqpWorker = class extends ADataWorker {
    constructor(name, hosts, queueParam, maxwaitTime = 50) {
        super(name, 1, 100, maxwaitTime);
        this.aliyunAmqpCli = require('aliyun-amqp-node-cli');
        this.amqplib = require('amqplib');
        pri(this, { params: hosts, queueParam: queueParam, dataList: [], dispose: false });
        //pri(this, { host: hosts.host, accessKeyId:hosts.accessKeyId, accessKeySecret: hosts.accessKeySecret, resourceOwnerId: hosts.resourceOwnerId, queueParam });
    }
    init(proc, func) {
        super.init(proc);
        this.connect(func);
    }
    async connect(func) {
        const {
            _,
            __
        } = pri(this);
        let amqplib = _.aliyunAmqpCli(__.params)(_.amqplib);
        __.conn = await amqplib.connect(`amqp://${__.params.host}`, {
            timeout: __.params.timeout || (300 * 1000),
        });
        console.info("connect to RabbitMQ/common success");
        __.channel = await __.conn.createChannel();
        __.channel.prefetch(__.queueParam.prefetch || 1);
        __.exchange = "common_topic";
        //await __.channel.assertExchange(__.exchange,'topic');
        __.queue = __.queueParam.name;
        await __.channel.assertQueue(__.queueParam.name, __.queueParam);
        //await __.channel.bindQueue(__.queue, __.exchange,'ROUTING_KEY');
        __.conn.on("error", function(err) {
            console.log('connection to RabbitQM error', err);
            __.conn = null;
            !__.dispose && V.once(_.connect, 1000);
        });

        __.conn.on("close", function() {
            console.error("connection to RabbitQM closed!");
            __.conn = null;
            !__.dispose && V.once(_.connect, 1000);
        });
        await __.channel.consume(__.queueParam.name, async function(message) {
            console.log(JSON.parse(message.content.toString()).count);
            try {
                await func(message);
            } catch (e) {
                __.channel.nack(message);
            }

            //__.dataList.push(message);
        }, { priority1: 0, noAck: false });
        return;
    }

    async go(ret, data) {
        return false;
    }

    async custom(ret, data) {
        const { _, __ } = pri(this);
        try {
            await V.callback2(_.go, _, ret.content.toString(), data);
            __.channel.ack(ret);
        } catch (e) {
            console.log(e.message);
            __.channel.nack(ret);
        }
        return false;
    }

    async rollback(ret, data) {
        const { _, __ } = pri(this);
        __.conn && __.channel.nack(ret);
        return false;
    }
}

/**
 * 创造customer来处理任务
 */
export const MACProcess = class extends CACProcess {
    constructor(worker, log, customersize, waittime) {
        super(worker, log, customersize, waittime);
        const { _, __ } = pri(this, {
            checker: new class {
                constructor() {
                    pri(this, { canRun: false });
                }
                start() {
                    const that = pri(this);
                    that.__.canRun = true;
                    this.go();
                }
                stop() {
                    const that = pri(this);
                    that.__.canRun = false;
                }
                go() {
                    const that = pri(this);
                    if (that.__.canRun && __.waittime > 0)
                        setTimeout(async() => {
                            try {
                                if (__.waitsessions.length && __.waitsessions[0].waittime.diff('s', new Date()) >= __.waittime / 1000) {
                                    const sessions = __.waitsessions;
                                    __.waitsessions = [];
                                    console.log('关闭等待中的session:' + sessions.length);
                                    await V.each(sessions, async v => {
                                        try {
                                            await v.dispose();
                                        } catch (e) {
                                            console.log('session dispose:', e.message);
                                        } finally {
                                            __.sessions--;
                                            __.dispose();
                                        }
                                    });
                                    console.log('多余的等待会话关闭完成');
                                    V.watch();
                                }
                            } catch (e) {
                                console.log('Check Exception:' + e.message);
                            }
                            that._.go();
                        }, __.waittime);
                }
            },
            next: function(session) {
                console.log('use:' + __.usesessions + ':' + __.waitsessions.length + ":" + __.sessions);
                __.usesessions--;
                if (__.canRun) {
                    __.waitsessions[__.waitsessions.length] = session;
                    session.waittime = new Date();
                } else
                if (__.isDispose)
                    session.dispose().then(() => {
                        __.sessions--;
                        __.dispose();
                    }).catch(e => {
                        __.sessions--;
                        __.dispose();
                    });
            },
            dispose: function() {
                if (__.sessions == 0 && __.isDispose) {
                    _.supdispose();
                    V.watch();
                    console.log('end');
                }
            },
            createSession: function() {
                let session = __.waitsessions.pop();
                if (session) { __.usesessions++; return session; } else if (__.sessions < __.customersize) {
                    session = new __.Session();
                    __.sessions++;
                    __.usesessions++;
                    return session;
                } else throw new Error('已经达到会话限制上限:' + __.customersize);
            },
            go: async function(ret) {
                try {
                    if (__.canRun && ret) {
                        const session = __.createSession();
                        delete session.waittime;
                        try {
                            return await session.custom(ret);
                        } finally {
                            __.next(session);
                        }
                    }
                    return null;
                } catch (e) {
                    console.log('等待处理结束2:' + e.message);
                    throw e;
                }
            }
        });
    }

    async init() {
        const { __ } = pri(this);
        __.canRun = true;
        V.watch(true);
        return __.worker.init(this, __.go);
    }
    async start() {
        const { __ } = pri(this);
        __.canRun = true;
        V.watch(true);
        __.checker.start();
        return false;
    };
    async stop() {
        const { __ } = pri(this);
        __.canRun = false;
        __.checker.stop();
        return false;
    }
    async dispose() {
        const { __ } = pri(this);
        this.stop();
        __.isDispose = true;
        return false;
    }
    supdispose() {
        super.dispose();
    }
}
export default { AProcess, AWorker, CACProcess, ADataWorker, ACronJob, CronWorker, start, ABulkWorker, AmqpWorker, MACProcess };
const pri = V.pris();